import { useEffect, useState } from 'react';
import { buildCategories, fetchBlogList, splitBlogLists } from './blogApi';

const useBlogList = () => {
  const [featuredPosts, setFeaturedPosts] = useState([]);
  const [latestPosts, setLatestPosts] = useState([]);
  const [categories, setCategories] = useState(['All Categories']);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;

    const load = async () => {
      setLoading(true);
      setError(null);

      try {
        const posts = await fetchBlogList();
        if (!active) return;

        const lists = splitBlogLists(posts);
        setFeaturedPosts(lists.featuredPosts);
        setLatestPosts(lists.latestPosts);
        setCategories(buildCategories(posts));
      } catch (err) {
        if (!active) return;
        setError(err);
        setFeaturedPosts([]);
        setLatestPosts([]);
        setCategories(['All Categories']);
      } finally {
        if (active) setLoading(false);
      }
    };

    load();

    return () => {
      active = false;
    };
  }, []);

  return {
    featuredPosts,
    latestPosts,
    categories,
    loading,
    error,
  };
};

export default useBlogList;
